/**
 * Route configuration — TaisaCore v2.5
 * Maps view IDs (used by components) to URL paths (used by React Router).
 */

export const routes = [
  { id: 'dashboard', path: '/' },
  { id: 'calendar', path: '/calendar' },
  { id: 'waiting-room', path: '/waiting-room' },
  { id: 'patients', path: '/patients' },
  { id: 'recalls', path: '/recalls' },
  { id: 'billing', path: '/billing' },
  { id: 'inventory', path: '/inventory' },
  { id: 'tasks', path: '/tasks' },
  { id: 'reports', path: '/reports' },
  { id: 'ai-hub', path: '/ai-hub' },
  { id: 'medications', path: '/medications' },
  { id: 'procedures', path: '/procedures' },
  { id: 'settings', path: '/settings' },
  { id: 'qa', path: '/qa' },
  { id: 'notifications', path: '/notifications' },
  { id: 'decisionary', path: '/decisionary' },
];

/** View-title lookup (bilingual) used by GlobalHeader */
export const viewTitles = {
  he: {
    'dashboard': 'דשבורד',
    'calendar': 'לוח תיאום',
    'waiting-room': 'חדר המתנה',
    'patients': 'מטופלים',
    'recalls': 'תזכורות',
    'billing': 'חיוב',
    'inventory': 'מלאי',
    'tasks': 'משימות',
    'reports': 'דוחות',
    'ai-hub': 'מרכז AI',
    'medications': 'תרופות',
    'procedures': 'פרוצדורות',
    'settings': 'הגדרות',
    'qa': 'QA דשבורד',
    'notifications': 'התראות',
    'decisionary': 'Decisionary',
  },
  en: {
    'dashboard': 'Dashboard',
    'calendar': 'Calendar',
    'waiting-room': 'Waiting Room',
    'patients': 'Patients',
    'recalls': 'Recalls',
    'billing': 'Billing',
    'inventory': 'Inventory',
    'tasks': 'Tasks',
    'reports': 'Reports',
    'ai-hub': 'AI Hub',
    'medications': 'Medications',
    'procedures': 'Procedures',
    'settings': 'Settings',
    'qa': 'QA Dashboard',
    'notifications': 'Notifications',
    'decisionary': 'Decisionary',
  },
};

/** viewId → path, e.g. 'calendar' → '/calendar' */
export const viewIdToPath = Object.fromEntries(
  routes.map((r) => [r.id, r.path])
);

/** path → viewId, e.g. '/calendar' → 'calendar' */
export const pathToViewId = Object.fromEntries(
  routes.map((r) => [r.path, r.id])
);
